import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }
});

let _token = null;
let _tokenReady = false;
let _resolveToken = null;

const _tokenPromise = new Promise((resolve) => {
    _resolveToken = resolve;
});

export const setApiToken = (token) => {
    _token = token;
    if (!_tokenReady) {
        _tokenReady = true;
        _resolveToken();
    }
};

api.interceptors.request.use(async (config) => {
    if (!_tokenReady) {
        await _tokenPromise;
    }
    if (_token) {
        config.headers.Authorization = `Bearer ${_token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401 && _token) {
            console.log('Error: no access permission for microservices.')
        }
        return Promise.reject(error);
    }
);

export default api
